var render = function render(){var _vm=this,_c=_vm._self._c;return _c('injury-donut',{attrs:{"docs":_vm.docs,"field":"type","colors":_vm.colors,"label-fn":_vm.injuryTypeLabel,"center-label":_vm.$t('statistics.distinct_types')}})
}
var staticRenderFns = []

export { render, staticRenderFns }